<template>
    <div class="product-add" v-loading="loading">
        <!--form表单-->
        <el-form ref="form" size="small" :model="form" label-width="180px">
            <!--基本信息-->
            <div class="common-form">基本信息</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="姓名：" :rules="[{ required: true, message: '请填写姓名' }]" prop="name">
                        <el-input v-model="form.name" class="max-w460" />
                    </el-form-item>
                    <el-form-item label="证件号：" :rules="[{ required: true, message: '请填写证件号' }]" prop="id_card">
                        <el-input v-model="form.id_card" class="max-w460" />
                    </el-form-item>
                    <el-form-item label="户籍所在地：" :rules="[{ required: true, message: '请选择户籍所在地' }]" prop="domicile_region_id">
                        <el-select v-model="form.domicile_province_id" placeholder="省" class="max-w150" @change="initCity">
                            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
                        </el-select>
                        <el-select v-if="form.domicile_province_id!=''" v-model="form.domicile_city_id" placeholder="市" class="max-w150" @change="initRegion">
                            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.domicile_province_id]['city']" :key='index1'></el-option>
                        </el-select>
                        <el-select v-if="form.domicile_city_id!=''" v-model="form.domicile_region_id" placeholder="区" class="max-w150" @change="initArea">
                            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.domicile_province_id]['city'][form.domicile_city_id]['region']" :key='index2'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="民族：" :rules="[{ required: true, message: '请选择民族' }]" prop="nationality_id">
                        <el-select v-model="form.nationality_id" clearable placeholder="请选择民族" style="width: 460px">
                            <el-option
                                v-for="item in nationalityList"
                                :key="item.nationality_id"
                                :label="item.nationality_name"
                                :value="item.nationality_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发票类型" :rules="[{ required: true, message: '请选择发票类型' }]" prop="invoice">
                        <el-select v-model="form.invoice" clearable placeholder="请选择发票类型" style="width: 460px">
                            <el-option
                                    v-for="item in invoiceList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别：" :rules="[{ required: true, message: '请选择性别' }]" prop="sex">
                        <el-select v-model="form.sex" clearable placeholder="请选择性别" style="width: 460px">
                            <el-option
                                v-for="item in sexList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手机号：" :rules="[{ required: true, message: '请填写手机号' }]" prop="phone">
                        <el-input v-model="form.phone" class="max-w460" />
                    </el-form-item>
                    <el-form-item label="现居址：" :rules="[{ required: true, message: '请选择现居址' }]" prop="current_region_id">
                        <el-select v-model="form.current_province_id" placeholder="省" class="max-w150" @change="initCurrentCity">
                            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
                        </el-select>
                        <el-select v-if="form.current_province_id!=''" v-model="form.current_city_id" placeholder="市" class="max-w150" @change="initCurrentRegion">
                            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.current_province_id]['city']" :key='index1'></el-option>
                        </el-select>
                        <el-select v-if="form.current_city_id!=''" v-model="form.current_region_id" placeholder="区" class="max-w150" @change="initCurrentArea">
                            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.current_province_id]['city'][form.current_city_id]['region']" :key='index2'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电子邮箱：" :rules="[{ required: true, message: '请填写电子邮箱(接收发票用)' }]" prop="email">
                        <el-input v-model="form.email" class="max-w460" />
                    </el-form-item>
                    <el-form-item label="‌纳税人识别号：" :rules="[{ required: true, message: '请填写‌纳税人识别号' }]" prop="tax" v-if="form.invoice == 2">
                        <el-input v-model="form.tax" class="max-w460" placeholder="‌纳税人识别号或统一社会信用代码" />
                    </el-form-item>
                </el-col>
            </el-row>

            <!--报考信息-->
            <div class="common-form">报考信息</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="报考专业：" :rules="[{ required: true, message: '请选择报考专业' }]" prop="major_id">
                        <el-select v-model="form.major_id" placeholder="请选择报考专业" disabled style="width: 460px">
                            <el-option
                                v-for="item in majorList"
                                :key="item.major_id"
                                :label="item.major_name"
                                :value="item.major_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位名称：" :rules="[{ required: true, message: '请填写单位名称' }]" prop="company">
                        <el-input v-model="form.company" class="max-w460" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="学历：" :rules="[{ required: true, message: '请选择学历' }]" prop="education_id">
                        <el-select v-model="form.education_id" clearable placeholder="请选择学历" style="width: 460px">
                            <el-option
                                v-for="item in educationList"
                                :key="item.education_id"
                                :label="item.education_name"
                                :value="item.education_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--附件信息-->
            <div class="common-form">附件信息</div>
            <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in attachedList" :key="index">
                    <el-form-item
                            :label="item.file[0].attached_name"
                            :rules="[{ required: true, message: item.file[0].attached_name }]"
                            :prop="item.file[0].attached_mark">
                        <div class="draggable-list">
                            <div v-if="item.picUrl" class="item">
                                <img :src="item.picUrl" alt="">
                                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,item.image)">
                                    <i class="el-icon-close"/>
                                </a>
                            </div>
                            <div v-else class="item img-select">
                                <el-upload
                                        ref="upload"
                                        action=""
                                        :show-file-list="false"
                                        multiple
                                        :limit="1"
                                        accept=".png, .jpg, .jpeg"
                                        :before-upload="onBeforeUploadImage"
                                        :http-request="UploadImage"
                                        :on-success="handleUploadSuccess.bind(null,{'index':index,'data':item})">
                                    <i class="el-icon-plus"/>
                                </el-upload>
                            </div>

                            <div class="example">
                                <el-image
                                        style="width: 110px; height: 110px"
                                        :src="item.file[0].example"
                                        :preview-src-list="srcList">
                                </el-image>
                            </div>
                        </div>

                    </el-form-item>
                </el-col>
            </el-row>

            <!--其他信息-->
            <div class="common-form">其他信息</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="证书邮寄地址：" :rules="[{ required: true, message: '请填写证书邮寄地址' }]" prop="address">
                        <el-input type="textarea" v-model="form.address" class="max-w460" placeholder="精确到街道及门牌号" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
            </el-row>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提 交</el-button>
            </div>
        </el-form>

    </div>
</template>

<script>
    import SignApi from '@/api/sign.js';
    import { getCookie } from '@/utils/base.js';
    import FileApi from '@/api/file.js'

    export default {
        data() {
            return {
                loading: true,
                token: getCookie('token_supplier'),
                signDetail: {},
                // form表单数据
                form: {
                    sign_id: null,
                    name: '',
                    sex: '',
                    id_card: '',
                    phone: '',
                    major_id: '',
                    company: '',
                    education_id: '',
                    selectDomicileCity: '',
                    domicile_province_id: '',
                    domicile_city_id: '',
                    domicile_region_id: '',
                    selectCurrentCity: '',
                    current_province_id: '',
                    current_city_id: '',
                    current_region_id: '',
                    nationality_id: '',
                    email: '',
                    invoice: '',
                    address: '',
                    one_inch_image: '', // 一寸免冠白底证件照
                    apply_image: '', // 职业技能等级认定申请表
                    id_card_front_image: '', // 身份证正面
                    id_card_back_image: '', // 身份证反面
                    integrity_commitment_image: '', // 诚信承诺书
                    diploma_image: '', // 个人毕业证书
                    study_trust_iamge: '', // 学信网学历证明
                    years_of_service_image: '', // 工作年限证明
                    work_experience_image: '', // 工作经历证明
                    social_security_image: '', // 个人社保缴费证明
                },
                sexList: [
                    {
                        name: '男',
                        value: 1,
                    },
                    {
                        name: '女',
                        value: 2,
                    }
                ],
                invoiceList: [
                    {
                        name: '增值税普通发票',
                        value: 2
                    },
                    /*{
                        name: '增值税专用发票',
                        value: 3
                    },*/
                    {
                        name: '不需要发票',
                        value: 1
                    }
                ],
                // 省市区
                areaList: [],
                domicile_province_name: '',
                domicile_region_name: '',
                domicile_area_name: '',
                current_province_name: '',
                current_region_name: '',
                current_area_name: '',
                majorList: [],
                educationList: [],
                nationalityList: [],
                // 专业关联附件数据
                attachedList: [],
                // 上传图片信息
                imageData: {},
                fileLoading: '',
                srcList: [],
            };
        },
        created() {
            this.form.sign_id = this.$route.query.sign_id

            // 获取数据
            this.getDetail();
        },
        methods: {
            // 获取报名详情
            getDetail() {
                let that = this;

                SignApi.getSignDetail({
                    sign_id: that.form.sign_id,
                    token: that.token
                }).then(res => {
                    that.signDetail = res.data.data

                    if(that.signDetail){
                        that.form.sign_id = that.signDetail.sign_id
                        that.form.name = that.signDetail.name
                        that.form.sex = that.signDetail.sex
                        that.form.id_card = that.signDetail.id_card
                        that.form.phone = that.signDetail.phone
                        that.form.company = that.signDetail.company
                        that.form.education_id = that.signDetail.education_id
                        that.form.education_id = that.signDetail.education_id
                        that.form.selectDomicileCity = that.signDetail.selectDomicileCity
                        that.form.domicile_province_id = that.signDetail.domicile_province_id
                        that.form.domicile_city_id = that.signDetail.domicile_city_id
                        that.form.domicile_region_id = that.signDetail.domicile_region_id
                        that.form.selectCurrentCity = that.signDetail.selectCurrentCity
                        that.form.current_province_id = that.signDetail.current_province_id
                        that.form.current_city_id = that.signDetail.current_city_id
                        that.form.current_region_id = that.signDetail.current_region_id
                        that.form.nationality_id = that.signDetail.nationality_id
                        that.form.email = that.signDetail.email
                        that.form.address = that.signDetail.address
                        that.form.major_id = that.signDetail.major_id
                        that.form.invoice = that.signDetail.invoice
                        that.form.tax = that.signDetail.tax
                        that.getData()
                    }

                    that.loading = false;
                }).catch(error => {

                });
            },

            // 获取数据
            getData() {
                let that = this;

                SignApi.getSignInfo({
                    major_id: that.form.major_id,
                    token: that.token
                }).then(res => {
                    that.signData = res.data.sign
                    that.majorList = res.data.major
                    that.educationList = res.data.education
                    that.nationalityList = res.data.nationality
                    that.attachedList = res.data.attached
                    that.areaList = res.data.regionData;

                    if(that.attachedList){
                        that.attachedList.forEach((item) => {
                            item.image = []
                            item.picUrl = ''
                            if (JSON.stringify(that.signDetail) === '{}') {
                                item.image = []
                                item.picUrl = ''
                            } else {
                                that.signDetail.signfile.forEach((itemfile) => {
                                    if(item.file[0].attached_mark == itemfile.type){
                                        let img = []
                                        img.push({
                                            file_id: itemfile.image_id,
                                            file_path: itemfile.file_path
                                        })
                                        item.image = img
                                        item.picUrl = itemfile.file_path

                                        that.form[item.file[0].attached_mark] = itemfile.file_path
                                    }
                                })
                            }
                        })
                        console.log(that.attachedList);

                        let list = []
                        that.attachedList.forEach(function(item) {
                            list.push(item.file[0].example)
                        });
                        that.srcList = list
                    }

                    // 户籍所在地--省市区文字
                    this.domicile_province_name = that.areaList[that.form.domicile_province_id].name
                    this.domicile_region_name = that.areaList[that.form.domicile_province_id].city[that.form.domicile_city_id].name
                    this.domicile_area_name = that.areaList[that.form.domicile_province_id].city[that.form.domicile_city_id].region[that.form.domicile_region_id].name

                    // 现居址--省市区文字
                    this.current_province_name = that.areaList[that.form.current_province_id].name
                    this.current_region_name = that.areaList[that.form.current_province_id].city[that.form.current_city_id].name
                    this.current_area_name = that.areaList[that.form.current_province_id].city[that.form.current_city_id].region[that.form.current_region_id].name

                    that.loading = false;
                }).catch(error => {

                });
            },

            // 户籍所在地--初始化城市id
            initCity(e) {
                this.domicile_province_name = this.areaList[e].name
                this.domicile_region_name = ''
                this.form.domicile_city_id = ''
            },
            // 户籍所在地--初始化区id
            initRegion(e) {
                this.domicile_region_name = this.areaList[this.form.domicile_province_id].city[e].name
                this.domicile_area_name = ''
                this.form.domicile_region_id = ''
            },
            // 户籍所在地--区名称赋值
            initArea(e) {
                this.domicile_area_name = this.areaList[this.form.domicile_province_id].city[this.form.domicile_city_id].region[e].name
            },

            // 现居址--初始化城市id
            initCurrentCity(e) {
                this.current_province_name = this.areaList[e].name
                this.current_region_name = ''
                this.form.current_city_id = ''
            },
            // 现居址--初始化区id
            initCurrentRegion(e) {
                this.current_region_name = this.areaList[this.form.current_province_id].city[e].name
                this.current_area_name = ''
                this.form.current_region_id = ''
            },
            // 现居址--区名称赋值
            initCurrentArea(e) {
                this.current_area_name = this.areaList[this.form.current_province_id].city[this.form.current_city_id].region[e].name
            },

            // 选择文件之前
            onBeforeUploadImage(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isLt5M) {
                    this.$message.error('上传图片大小不能超过 5MB!');
                }

                return isLt5M;
            },

            // 上传文件
            UploadImage(param) {
                const that = this

                that.fileLoading = this.$loading({
                    lock: true,
                    text: '文件上传中,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })

                const formData = new FormData()
                formData.append('iFile', param.file)
                formData.append('file_type', 'image')

                FileApi.uploadFile(formData)
                    .then(res => {
                        that.imageData = res.data

                        param.onSuccess() // 上传成功的文件会显示绿色的对勾
                        // 但是我们上传成功了文件， fileList 里面的值却没有改变，还好有on-change指令可以使用
                    })
                    .catch(res => {
                        this.fileLoading.close()
                        that.$message({
                            message: '本次上传文件失败',
                            type: 'warning'
                        })
                        param.onError()
                    })
            },
            // 文件上传成功时的钩子
            handleUploadSuccess(obj, res, file) {
                let img = []
                img.push(this.imageData)

                this.attachedList[obj.index].image = img
                this.attachedList[obj.index].picUrl = this.imageData.file_path

                this.form[this.attachedList[obj.index].file[0].attached_mark] = this.imageData.file_path

                this.$forceUpdate()
                this.fileLoading.close()
            },

            // 删除图片
            deleteImg(index) {
                this.attachedList[index].image = []
                this.attachedList[index].picUrl = ''
                this.form[this.attachedList[index].file[0].attached_mark] = ''

                this.$forceUpdate()
            },

            // 提交
            onSubmit() {
                const that = this

                const params = that.form

                // 户籍所在地文字拼接
                params.selectDomicileCity =  that.domicile_province_name + '/' + that.domicile_region_name + '/' + that.domicile_area_name
                // 现居址文字拼接
                params.selectCurrentCity = that.current_province_name + '/' + that.current_region_name + '/' + that.current_area_name

                // 附件材料转json字符串处理
                params.image = JSON.stringify(that.attachedList)

                // token
                params.token = that.token

                that.$refs.form.validate(valid => {
                    if (valid) {
                        that.loading = true

                        SignApi.editSign(params, true).then(res => {
                            that.loading = false
                            that.$message({
                                message: '报名成功',
                                type: 'success'
                            })
                            that.$router.push('/mysign/index')
                        }).catch(() => {
                            that.loading = false
                        })
                    } else {
                        that.$message({
                            message: '请检查必填项是否填写完整',
                            type: 'error'
                        })
                    }
                })
            },

        }
    };
</script>

<style lang="scss" scoped>
    .product-add{
        margin-bottom: 30px;
    }
    .el-form-item{
        margin-bottom: 25px;
    }
    .common-button-wrapper{
        bottom: 60px;
        /*background: transparent;*/
    }

    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
        cursor: pointer;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
    .draggable-list .example{
        margin-top: 10px;
        margin-right: 10px;
        border: 1px solid #eee;
    }
    .draggable-list .example img{
        width: 110px;
        height: 110px;
    }
</style>



// WEBPACK FOOTER //
// src/views/mysign/detail.vue